import { render, staticRenderFns } from "./Span.vue?vue&type=template&id=9b6ceb1a"
import script from "./Span.vue?vue&type=script&lang=js"
export * from "./Span.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports